import { EditNotifications } from '@mui/icons-material';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Footer from '../../Components/Footer/Footer';
import Header from '../../Components/Header/Header';
import InnerHeaderContent from '../../Components/Header/InnerHeaderContent';
import ProfileTab from '../../Components/Profile/ProfileTabs';
import '../../assets/css/AboutUs.css';
import '../../assets/css/Packages.css'
import '../../assets/css/Contact.css'
import '../../assets/css/BlogDetail.css'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faLocationDot, faPhone, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import blg2 from '../../assets/images/blg2.png'
import { useDispatch } from 'react-redux';
import { SingleBlogApi } from '../../Redux/Auth/Auth_Action';
import { showLoader } from '../../Redux/services/Loader';
import { toast } from 'react-toastify';


const BlogDetails = () => {
    let navigate = useNavigate();
    const dispatch = useDispatch();
    let param = useParams();
    // console.log(param);

    const [state, setState] = useState({ blogdetail: [] })
    const [podcast, setPodcast] = useState({ allPodcast: [] });

    const SingleBlog = () => {
        dispatch(SingleBlogApi(param))
            .then((res) => {
                // console.log(res);
                setState({ ...state, blogdetail: res?.data?.response?.data?.data })
                showLoader("none");
            })
            .catch((e) => {
                console.log(e);
            })
    }



    useEffect(() => {
        SingleBlog();
    }, []);

    useEffect(() => {
        window.scroll(0, 0);
    }, []);

    // console.log(state);

    return (
        <div className='Contact packages blog-details'>
            <section className='reamining_header_background pos-rel'>
                <Header />
                <InnerHeaderContent pageName={"Blogs"} />
            </section>
            <section className='blogDetail-content'>
                <div className='container'>
                    <div className='img-box'>
                        {(state?.blogdetail[0]?.media_url.slice(-3) === "mp4")
                            ?
                            <video width="100%" height="500" controls controlsList="nodownload" >
                                <source src={`${state?.blogdetail[0]?.media_url}`} type="video/mp4" />
                            </video>
                            :
                            <img src={state?.blogdetail[0]?.media_url} alt="blog visual" className='image-fluid image-width' />
                        }
                        {/* <img src={state?.blogdetail[0]?.image} alt="blog visual" className='image-fluid image-width' /> */}
                    </div>
                    <p className='blog-title'>{state?.blogdetail[0]?.title}
                    </p>
                    <p className='time'>{state?.blogdetail[0]?.added_by}  |
                        {/* {state?.blogdetail[0]?.created_at.slice(0, 10)} */}
                        <span className='ml-1'>{state?.blogdetail[0]?.created_at.slice(5, 7)}</span>
                        <span>{state?.blogdetail[0]?.created_at.slice(7, 10)}</span>
                        <span>-{state?.blogdetail[0]?.created_at.slice(0, 4)}</span>
                    </p>
                    <div className='txt-dngrs brkbrk' style={{ color: "white!important" }} dangerouslySetInnerHTML={{ __html: state?.blogdetail[0]?.description }}></div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default BlogDetails;
